<app-system-message></app-system-message>

<div [ngClass]="theme.getThemeClass()" class="container-fluid entitiesContainer"> <!-- (window:scroll)="onScroll()"-->

    <!-- Header section with navigation menu -->
    <header class="entitiesHeader">
        <nav [ngClass]="theme.getThemeClass()" class="navbar navbar-expand-lg navbar-light bg-light">
          <div [ngClass]="theme.getThemeClass()" class="navbar-nav flex-nowrap" id="navbarNavAltMarkup">
            <a class="nav-item nav-link" href="javascript:void(0)"
            (click)="clientsClicked()" [ngClass]="{'active' : isClientsActive}">
            {{ 'userlistNavMenuClients' | translate }}
            </a>
            <a class="nav-item nav-link" href="javascript:void(0)"
            (click)="distributorsClicked()" [ngClass]="{'active' : isDistributorsActive}">
            {{ 'userlistNavMenuDistributors' | translate }}
            </a>
            <a class="nav-item nav-link" href="javascript:void(0)"
            (click)="operatorClicked()" [ngClass]="{'active' : isOperatorActive}">
            {{ 'userlistNavMenuOperators' | translate }}
            </a>
            <a class="nav-item nav-link" href="javascript:void(0)"
            (click)="locationsClicked()" [ngClass]="{'active' : isLocationActive}">
            {{ 'binListViewLocation' | translate }}
            </a>
            <a class="nav-item nav-link" href="javascript:void(0)"
            (click)="apiClicked()" [ngClass]="{'active' : isApiActive}">
            {{ 'apiManagement' | translate }}
            </a>
          </div>
        </nav>
    </header>

    <!-- Components list add to the entitie component -->
    @if (isDistributorsActive) {<app-distributors-list class="container-fluido componentBelow"></app-distributors-list>}
    @if (isClientsActive) {<app-client-list class="container-fluido componentBelow"></app-client-list>}
    @if (isOperatorActive) {<app-operator-list class="container-fluido componentBelow"></app-operator-list>}
    @if (isLocationActive) {<app-entities-location-list class="container-fluido componentBelow"></app-entities-location-list>}
    @if (isApiActive) {<app-entities-api-management class="container-fluido componentBelow"></app-entities-api-management>}
</div>
